// Add authentication token to every request
export const authInterceptor = config => {
  config.headers.countryCode = 'MX'
  const token = localStorage.getItem('msalAccessToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

// Attach the interceptor to an Axios instance
export const attachAuthInterceptor = axiosInstance => {
  axiosInstance.interceptors.request.use(authInterceptor, error => Promise.reject(new Error(error)))
}
